import React from "react";
import { PortalPageFallback } from "./PortalLoader";

/** Suspense / route chunk loading — same orbit loader as API fetches. */
export default function PortalRouteFallback({ message = "Loading page" }) {
  return <PortalPageFallback message={message} className="min-h-[40vh]" />;
}
